import { render } from "./WishListBooks.vue?vue&type=template&id=2337a5ff&scoped=true"
import script from "./WishListBooks.vue?vue&type=script&lang=js"
export * from "./WishListBooks.vue?vue&type=script&lang=js"

import "./WishListBooks.vue?vue&type=style&index=0&id=2337a5ff&scoped=true&lang=css"

import exportComponent from "C:\\Surilova\\FrontEnd\\Bookshelf-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2337a5ff"]])

export default __exports__